import "./segmented.css";
import { Segmented } from './segmented';
export default Segmented;